import { PublicLocation } from './types.js';

export const publicLocations: PublicLocation[] = [
  {
    id: 'loc-azueta',
    slug: 'azueta',
    name: 'Azueta',
    addressLine1: 'José María Azueta 27 Local B',
    neighborhood: 'Centro',
    borough: 'Cuauhtémoc',
    postalCode: '06000',
    city: 'Ciudad de México',
    breakfastHours: 'Lun a Vie 8:00 – 13:00 hrs | Sáb y Dom 9:00 – 14:00 hrs',
    lunchHours: 'Lun a Vie 13:00 – 17:00 hrs',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Jose+Maria+Azueta+27+Colonia+Centro+Cuauhtemoc+CDMX',
    deliveryUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
    active: true,
  },
  {
    id: 'loc-bajio',
    slug: 'bajio',
    name: 'Bajío',
    addressLine1: 'Bajío 374',
    neighborhood: 'Hipódromo Condesa',
    borough: 'Cuauhtémoc',
    postalCode: '06170',
    city: 'Ciudad de México',
    breakfastHours: 'Lun a Vie 8:00 – 13:00 hrs | Sáb y Dom 9:00 – 14:00 hrs',
    lunchHours: 'Lun a Vie 13:00 – 17:00 hrs',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Bajio+374+Hipodromo+Condesa+Cuauhtemoc+CDMX',
    deliveryUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
    active: true,
  },
  {
    id: 'loc-dakota',
    slug: 'dakota',
    name: 'Dakota',
    addressLine1: 'Galveston 33 Local A (Esq. Dakota)',
    neighborhood: 'Nápoles',
    borough: 'Benito Juárez',
    postalCode: '03810',
    city: 'Ciudad de México',
    breakfastHours: 'Lun a Vie 8:00 – 13:00 hrs | Sáb y Dom 9:00 – 14:00 hrs',
    lunchHours: 'Lun a Vie 13:00 – 17:00 hrs',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Galveston+33+Napoles+Benito+Juarez+CDMX',
    deliveryUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
    active: true,
  },
  {
    id: 'loc-lerma',
    slug: 'lerma',
    name: 'Lerma',
    addressLine1: 'Río Lerma 271 (Esq. Río de la Plata)',
    neighborhood: 'Cuauhtémoc',
    borough: 'Cuauhtémoc',
    postalCode: '06500',
    city: 'Ciudad de México',
    breakfastHours: 'Lun a Vie 8:00 – 13:00 hrs | Sáb y Dom 9:00 – 14:00 hrs',
    lunchHours: 'Lun a Vie 13:00 – 17:00 hrs',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Rio+Lerma+271+Cuauhtemoc+CDMX',
    deliveryUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
    active: true,
  },
  {
    id: 'loc-melchor',
    slug: 'melchor',
    name: 'Melchor',
    addressLine1: 'Melchor Ocampo 12 Local A',
    neighborhood: 'Cuauhtémoc',
    borough: 'Cuauhtémoc',
    postalCode: '06500',
    city: 'Ciudad de México',
    breakfastHours: 'Lun a Vie 8:00 – 13:00 hrs | Sáb y Dom 9:00 – 14:00 hrs',
    lunchHours: 'Lun a Vie 13:00 – 17:00 hrs',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Melchor+Ocampo+12+Cuauhtemoc+CDMX',
    deliveryUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
    active: true,
  },
  {
    id: 'loc-nazas',
    slug: 'nazas',
    name: 'Nazas',
    addressLine1: 'Río Nazas 210 (Esq. Río Ganges)',
    neighborhood: 'Cuauhtémoc',
    borough: 'Cuauhtémoc',
    postalCode: '06500',
    city: 'Ciudad de México',
    breakfastHours: 'Lun a Vie 8:00 – 13:00 hrs | Sáb y Dom 9:00 – 14:00 hrs',
    lunchHours: 'Lun a Vie 13:00 – 17:00 hrs',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Rio+Nazas+210+Cuauhtemoc+CDMX',
    deliveryUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
    active: true,
  },
  {
    id: 'loc-panuco',
    slug: 'panuco',
    name: 'Pánuco',
    addressLine1: 'Río Pánuco 137',
    neighborhood: 'Cuauhtémoc',
    borough: 'Cuauhtémoc',
    postalCode: '06500',
    city: 'Ciudad de México',
    breakfastHours: 'Lun a Vie 8:00 – 13:00 hrs | Sáb y Dom 9:00 – 14:00 hrs',
    lunchHours: 'Lun a Vie 13:00 – 17:00 hrs',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Rio+Panuco+137+Cuauhtemoc+CDMX',
    deliveryUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
    active: true,
  },
  {
    id: 'loc-parroquia',
    slug: 'parroquia',
    name: 'Parroquia',
    addressLine1: 'Parroquia 810',
    neighborhood: 'Del Valle',
    borough: 'Benito Juárez',
    postalCode: '03104',
    city: 'Ciudad de México',
    breakfastHours: 'Lun a Vie 8:00 – 13:00 hrs | Sáb y Dom 9:00 – 14:00 hrs',
    lunchHours: 'Lun a Vie 13:00 – 17:00 hrs',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Parroquia+810+Del+Valle+Benito+Juarez+CDMX',
    deliveryUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
    active: true,
  },
  {
    id: 'loc-veracruz',
    slug: 'veracruz',
    name: 'Veracruz',
    addressLine1: 'Veracruz 111 (Esq. Parque España)',
    neighborhood: 'Condesa',
    borough: 'Cuauhtémoc',
    postalCode: '06140',
    city: 'Ciudad de México',
    breakfastHours: 'Lun a Vie 8:00 – 13:00 hrs | Sáb y Dom 9:00 – 14:00 hrs',
    lunchHours: 'Lun a Vie 13:00 – 17:00 hrs',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Veracruz+111+Condesa+Cuauhtemoc+CDMX',
    deliveryUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
    active: true,
  },
  {
    id: 'loc-yosemite',
    slug: 'yosemite',
    name: 'Yosemite',
    addressLine1: 'Yosemite 54 Local D',
    neighborhood: 'Nápoles',
    borough: 'Benito Juárez',
    postalCode: '03810',
    city: 'Ciudad de México',
    breakfastHours: 'Lun a Vie 8:00 – 13:00 hrs | Sáb y Dom 9:00 – 14:00 hrs',
    lunchHours: 'Lun a Vie 13:00 – 17:00 hrs',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Yosemite+54+Napoles+Benito+Juarez+CDMX',
    deliveryUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
    active: true,
  },
  {
    id: 'loc-benjamin-hill',
    slug: 'benjamin-hill',
    name: 'Benjamin Hill',
    addressLine1: 'Benjamin Hill 131',
    neighborhood: 'Hipódromo Condesa',
    borough: 'Cuauhtémoc',
    postalCode: '06170',
    city: 'Ciudad de México',
    breakfastHours: 'Lun a Vie 8:00 – 13:00 hrs | Sáb y Dom 9:00 – 14:00 hrs',
    lunchHours: 'Lun a Vie 13:00 – 17:00 hrs',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Benjamin+Hill+131+Hipodromo+Condesa+Cuauhtemoc+CDMX',
    deliveryUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
    active: true,
  },
  {
    id: 'loc-ajusco',
    slug: 'ajusco',
    name: 'Ajusco',
    addressLine1: 'Ajusco 49',
    neighborhood: 'Portales Sur',
    borough: 'Benito Juárez',
    postalCode: '03300',
    city: 'Ciudad de México',
    breakfastHours: 'Lun a Vie 8:00 – 13:00 hrs | Sáb y Dom 9:00 – 14:00 hrs',
    lunchHours: 'Lun a Vie 13:00 – 17:00 hrs',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Ajusco+49+Portales+Sur+Benito+Juarez+CDMX',
    deliveryUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
    active: true,
  },
  {
    id: 'loc-santa-fe',
    slug: 'santa-fe',
    name: 'Santa Fe',
    addressLine1: 'Blvrd Reforma 5420, La Rosita, El Yaqui',
    neighborhood: 'Santa Fe / El Yaqui',
    borough: 'Cuajimalpa de Morelos',
    postalCode: '05340',
    city: 'Ciudad de México',
    breakfastHours: 'Lun a Vie 8:00 – 13:00 hrs | Sáb y Dom 9:00 – 14:00 hrs',
    lunchHours: 'Lun a Vie 13:00 – 17:00 hrs',
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Boulevard+Reforma+5420+Cuajimalpa+CDMX',
    deliveryUrl: 'https://www.rappi.com.mx/restaurantes/1930440050-dona-blanca',
    active: true,
  },
];
